// @flow
import React, {useEffect, useRef, useState} from 'react';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {makeStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {MapDrawing} from '../../../map/map-drawing/MapDrawing';
import {useMapProvider} from '../../../map/utils';

import type {ShippingDetail, AddressGeo} from '../../../../entities';
import type {MapLocation} from '../../../map/map-drawing/MapDrawing';

type Props = {
  shippingDetail?: ShippingDetail,
  open: boolean,
  shippingAddressGeo: AddressGeo,
  handleCloseModal: () => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '24px',
  },
  button: {
    padding: '4px 32px',
  },
  map: {
    width: '80vw',
    height: '100%',
    margin: '12px auto',
    minHeight: '40vh',
    maxWidth: '600px',
  },
  title: {
    fontStyle: 'normal',
    fontWeight: 600,
    margin: '12px auto',
    fontSize: '18px',
    lineHeight: '24px',
    textAlign: 'center',
    color: '#3A3A49',
  },
  address: {
    marginBottom: '12px auto',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#717190',
    textAlign: 'center',
  },
  divider: {
    border: '1px solid #E8E8ED',
    margin: '12px auto',
  },
  titleWrapper: {
    width: '100%',
  },
}));
export default function MapModal(props: Props) {
  const {open, handleCloseModal, shippingAddressGeo} = props;
  const classes = useStyles();
  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <div className={classes.titleWrapper}>
          <div className={classes.title}>Dirección de cliente</div>
          <hr className={classes.divider} />
          <p className={classes.address}>{shippingAddressGeo.address1}</p>
        </div>
        <Map
          lat={Number(shippingAddressGeo.lat)}
          lng={Number(shippingAddressGeo.lng)}
        />
        <CustomButton
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={handleCloseModal}
        >
          Cerrar
        </CustomButton>
      </div>
    </CustomModal>
  );
}

function Map(props: MapLocation) {
  const {lng, lat} = props;

  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const mapRef = useRef<HTMLDivElement | null>(null);

  const classes = useStyles();

  const [, , mapDrawing]: [any, any, ?MapDrawing] = useMapProvider(
    undefined,
    undefined,
    'GOOGLE'
  );

  useEffect(() => {
    if (mapDrawing && mapRef && mapRef.current && !map && !marker) {
      const map = mapDrawing.drawMap(mapRef.current, {
        lat: lat,
        lng: lng,
      });
      setMap(map);

      setMarker(
        mapDrawing.drawMarker(
          map,
          {
            lat: lat,
            lng: lng,
          },
          '#E13065',
          {draggable: false}
        )
      );
    }
  }, [lat, lng, map, mapDrawing, marker]);

  return <div className={classes.map} ref={mapRef} />;
}

MapModal.propTypes = {
  shippingData: PropTypes.object,
  open: PropTypes.bool,
  shippingAddressGeo: PropTypes.object,
  handleCloseModal: PropTypes.func,
};
